// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreApprovals = (client) => ({
    /**
     * `GET /store/approvals`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/approvals/route.ts
     */
    list: (query, headers) => client.fetch("/store/approvals", { method: "GET", query, headers }),
    /**
     * `POST /store/approvals/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/store/approvals/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/store/approvals/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=approvals.js.map